@let messages = conversationStore.messages();

<div class="wrapper display-flex flex-direction-column">
  @for (message of messages; track message.fe_message_id ?? message.timestamp) {
    @let isNewMessageGroup = $first || message.is_me !== messages[$index - 1].is_me;
    <sb-message
      [boostable]="messageWithBoostToggle() === message"
      [class.mt-1@r]="!$first && !isNewMessageGroup"
      [class.mt-4@r]="!$first && isNewMessageGroup"
      [conversation]="conversation"
      [message]="message"
      [ngClass]="message.is_me ? 'align-self-flex-end' : 'align-self-flex-start'"
      [photoUrl]="isNewMessageGroup ? conversation.profile.profile_photo_url : undefined"
      (messageChanged)="messageChanged.emit()"
    />

    @if (message === messageWithReadReceipts()) {
      @if (conversation.read_receipts_locked) {
        <button
          class="align-self-flex-end mt-2"
          sbButton
          [bold]="true"
          [processing]="conversationStore.unlockReadReceiptsInProgress()"
          [size]="'tiny'"
          [variant]="'fill-gold'"
          (click)="onShowReadReceiptsClick(message)"
        >
          <sb-icon [name]="'lock'" />
          Show Read Receipts
        </button>
      } @else {
        <div class="align-self-flex-end t-10@r mt-1">
          @if (conversation.read_by_them) {
            <span class="color-blue"><sb-icon [name]="'doublecheck'" /> Read</span>
          } @else {
            <span class="color-ash"><sb-icon [name]="'check'" /> Sent</span>
          }
        </div>
      }
    }
  }

  @if (conversationStore.otherProfileIsTyping()) {
    @let lastMessage = messages[messages.length - 1];
    <sb-message-typing
      [ngClass]="lastMessage?.is_me ? 'mt-4@r' : 'mt-2'"
      [photoUrl]="conversation.profile.profile_photo_url"
    />
  }
</div>
